document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector(".gsap-hero")) return;

  gsap.from(".gsap-hero-title", {
    opacity: 0,
    y: 40,
    duration: 1
  });

  gsap.from(".gsap-hero-text", {
    opacity: 0,
    y: 30,
    duration: 0.9,
    delay: 0.2
  });

  gsap.from(".gsap-hero-btn", {
    opacity: 0,
    y: 20,
    duration: 0.8,
    delay: 0.4
  });
});


gsap.registerPlugin(ScrollTrigger);

const monitorSection = document.querySelector(".monitor-scroll");

if (monitorSection) {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: monitorSection,
      start: "top top",
      end: "bottom bottom",
      scrub: true
    }
  });

  tl.from(".monitor-image img", {
    scale: 0.9
  })
  .to(".step-1", { opacity: 1 })
  .to(".step-1", { opacity: 0 })
  .to(".step-2", { opacity: 1 })
  .to(".step-2", { opacity: 0 })
  .to(".step-3", { opacity: 1 });
}
